module.exports = __webpack_public_path__ + "img/img_title_introduce.72d2af73.png";